import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';

export const deleteSalaryHistoryOperation = async (
  salaryId: number,
): Promise<boolean> => {
  try {
    await appApi.deleteAccountantSalary(salaryId);
    toast.success('המשכורת נמחקה בהצלחה');
    return true;
  } catch (e) {
    toast.error('מחיקת המשכורת נכשלה, נסה שוב בעוד מספר רגעים...');
    return false;
  }
};
